module.exports = __webpack_public_path__ + "static/img/usa.4d4204a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idiomas/usa.png
// module id = L2z2
// module chunks = 0